/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OAuthBindMobileCodeReqVo
 */
export interface OAuthBindMobileCodeReqVo {
    /**
     * 绑定凭证
     * OAuth绑定凭证
     * @type {string}
     * @memberof OAuthBindMobileCodeReqVo
     */
    oauthBindToken: string;
    /**
     * 待绑定手机号
     * 待绑定手机号
     * @type {string}
     * @memberof OAuthBindMobileCodeReqVo
     */
    mobileNumber: string;
}

/**
 * Check if a given object implements the OAuthBindMobileCodeReqVo interface.
 */
export function instanceOfOAuthBindMobileCodeReqVo(value: object): value is OAuthBindMobileCodeReqVo {
    if (!('oauthBindToken' in value) || value['oauthBindToken'] === undefined) return false;
    if (!('mobileNumber' in value) || value['mobileNumber'] === undefined) return false;
    return true;
}

export function OAuthBindMobileCodeReqVoFromJSON(json: any): OAuthBindMobileCodeReqVo {
    return OAuthBindMobileCodeReqVoFromJSONTyped(json, false);
}

export function OAuthBindMobileCodeReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OAuthBindMobileCodeReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'oauthBindToken': json['oauthBindToken'],
        'mobileNumber': json['mobileNumber'],
    };
}

export function OAuthBindMobileCodeReqVoToJSON(json: any): OAuthBindMobileCodeReqVo {
    return OAuthBindMobileCodeReqVoToJSONTyped(json, false);
}

export function OAuthBindMobileCodeReqVoToJSONTyped(value?: OAuthBindMobileCodeReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'oauthBindToken': value['oauthBindToken'],
        'mobileNumber': value['mobileNumber'],
    };
}

